// extracted by mini-css-extract-plugin
export var col = "menu-module--col--3UTt3";
export var col_link = "menu-module--col_link--2Zrsj";
export var col_list = "menu-module--col_list--1-CA8";
export var soon = "menu-module--soon--qzif-";
export var disabel = "menu-module--disabel--JTcVb";